import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { FormTitle, FormWrapper, FormDivider } from 'libs/forms/styles';
import Paragraph from 'components/Paragraph';
import { FullWidthDivider } from 'legacyComponents/styled/lib';
import { ButtonGroup } from 'legacyComponents/styles';

import {
  SeatsFormWrapper,
  SeatsFormItem,
  SeatsFormItemTitle,
  SeatsFormItemValue,
  Sign,
  SeatInput,
  ButtonStyled,
} from 'apps/payment/styles';

export const AddSeatsForm = withNamespaces()(
  observer(({ paymentSpace, paymentSpacePreview }) => {
    const { subscription } = paymentSpace;
    const { seats } = subscription;
    const { addSeatsAmount } = seats;

    const preview = paymentSpacePreview && paymentSpacePreview.preview;
    const displayPreview = addSeatsAmount && preview;

    const currentMonthlyDisplayAmount = subscription.displayNextAmount;

    const newTotalSeats = displayPreview
      ? preview.seats.totalSubSeats
      : seats.newTotalSeats;
    const newExtraSeats = displayPreview
      ? preview.seats.optionalExtraSeats
      : seats.newOptionalExtraSeats;
    const newExtraDisplayAmount = displayPreview
      ? preview.displayOptionalExtraAmount
      : '-';
    const newFinalDisplayAmount = displayPreview
      ? preview.displayFinalAmount
      : '-';
    const displayInitialAmount = displayPreview
      ? preview.displayInitialAmount
      : '-';
    const displayPerSeatAmount = displayPreview
      ? preview.displayPerSeatAmount
      : '-';

    return (
      <SeatsFormWrapper>
        <FormTitle>
          <Trans>Adding seats</Trans>:
        </FormTitle>
        <FormDivider />
        <FormWrapper posting={false} responsive>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Current seats</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{seats.totalSubSeats}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Add seats</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Sign>+</Sign>
              <SeatInput
                autoFocus
                value={addSeatsAmount}
                onChange={e => seats.Update('add', e.target.value)}
              />
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <strong>
                  <Trans>New total seats</Trans>:
                </strong>
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{newTotalSeats}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Cost per seat</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{displayPerSeatAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>First {seats.includedPlanSeats} seats</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{displayInitialAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          {newExtraSeats ? (
            <SeatsFormItem>
              <SeatsFormItemTitle>
                <Paragraph>
                  <Trans>Extra {newExtraSeats} seats</Trans>:
                </Paragraph>
              </SeatsFormItemTitle>
              <SeatsFormItemValue>
                <Paragraph>{newExtraDisplayAmount}</Paragraph>
              </SeatsFormItemValue>
            </SeatsFormItem>
          ) : null}
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Current monthly total</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{currentMonthlyDisplayAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <strong>
                  <Trans>New monthly total</Trans>:
                </strong>
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>
                <strong>{newFinalDisplayAmount}</strong>
              </Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <ButtonGroup>
            <ButtonStyled
              variant='secondary'
              size='small'
              onClick={() => seats.SetFormVisibility(null)}
              text='Cancel'
              outline
            />
            <ButtonStyled
              size='small'
              onClick={seats.ConfirmAdd}
              disabled={!preview}
              text='Save'
            />
          </ButtonGroup>
        </FormWrapper>
      </SeatsFormWrapper>
    );
  }),
);

AddSeatsForm.propTypes = {
  appManager: PropTypes.object,
};
